import { useState, useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { packs } from '../../mocks/products';
import { Link } from 'react-router-dom';
import Button from '../../components/base/Button';

export default function Packages() {
  const [sortBy, setSortBy] = useState<'price' | 'savings'>('savings');
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date();
      const nextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1);
      const difference = nextMonth.getTime() - now.getTime();

      return {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60)
      };
    };

    setTimeLeft(calculateTimeLeft());
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const sortedPacks = [...packs].sort((a, b) => {
    if (sortBy === 'price') {
      return a.packPrice - b.packPrice;
    }
    return b.savings - a.savings;
  });

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      <div className="pt-32 pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <div className="inline-block bg-red-600 text-white px-6 py-3 rounded-full text-sm font-bold mb-6 animate-pulse">
              <i className="ri-flashlight-fill mr-2"></i>
              OFERTAS FLASH - RENOVACIÓN MENSUAL
            </div>
            <h1 className="text-5xl font-bold text-gray-900 mb-4">
              Packs Exclusivos del Mes
            </h1>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-8">
              Stock limitado. Cada día 1 del mes lanzamos nuevas ofertas irrepetibles. ¡Aprovecha antes de que se agoten!
            </p>

            <div className="bg-gradient-to-br from-orange-600 to-red-600 rounded-2xl p-8 max-w-3xl mx-auto mb-12 text-white">
              <p className="text-lg mb-4 font-semibold flex items-center justify-center">
                <i className="ri-time-line mr-2 text-2xl"></i>
                Esta oferta termina en:
              </p>
              <div className="grid grid-cols-4 gap-4">
                <div className="bg-white/20 backdrop-blur-sm rounded-lg p-4">
                  <div className="text-4xl font-bold">{timeLeft.days}</div>
                  <div className="text-white/90 text-sm mt-1">Días</div>
                </div>
                <div className="bg-white/20 backdrop-blur-sm rounded-lg p-4">
                  <div className="text-4xl font-bold">{timeLeft.hours}</div>
                  <div className="text-white/90 text-sm mt-1">Horas</div>
                </div>
                <div className="bg-white/20 backdrop-blur-sm rounded-lg p-4">
                  <div className="text-4xl font-bold">{timeLeft.minutes}</div>
                  <div className="text-white/90 text-sm mt-1">Min</div>
                </div>
                <div className="bg-white/20 backdrop-blur-sm rounded-lg p-4">
                  <div className="text-4xl font-bold">{timeLeft.seconds}</div>
                  <div className="text-white/90 text-sm mt-1">Seg</div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center mb-12">
            <div className="inline-flex bg-white rounded-lg p-1 shadow-md">
              <button
                onClick={() => setSortBy('savings')}
                className={`px-6 py-2 rounded-lg text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                  sortBy === 'savings'
                    ? 'bg-orange-600 text-white'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                <i className="ri-percent-line mr-2"></i>
                Mayor Ahorro
              </button>
              <button
                onClick={() => setSortBy('price')}
                className={`px-6 py-2 rounded-lg text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                  sortBy === 'price'
                    ? 'bg-orange-600 text-white'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                <i className="ri-money-euro-circle-line mr-2"></i>
                Menor Precio
              </button>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {sortedPacks.map((pack) => (
              <div 
                key={pack.id}
                className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 border-2 border-gray-200 hover:border-orange-400 relative"
              >
                {pack.limitedStock && pack.limitedStock < 30 && (
                  <div className="absolute top-4 left-4 bg-red-600 text-white px-4 py-2 rounded-full text-sm font-bold z-10 animate-pulse">
                    <i className="ri-alarm-warning-fill mr-1"></i>
                    ¡Solo quedan {pack.limitedStock}!
                  </div>
                )}

                <div className="relative h-80 overflow-hidden">
                  <img 
                    src={pack.image} 
                    alt={pack.name}
                    className="w-full h-full object-cover object-top"
                  />
                  {pack.freeShipping && (
                    <div className="absolute top-4 right-4 bg-green-500 text-white px-4 py-2 rounded-full text-sm font-semibold flex items-center space-x-2">
                      <i className="ri-truck-line"></i>
                      <span>Envío Gratis</span>
                    </div>
                  )}
                  {pack.featured && (
                    <div className="absolute top-16 right-4 bg-yellow-400 text-gray-900 px-4 py-2 rounded-full text-sm font-semibold">
                      <i className="ri-star-fill mr-1"></i>
                      Top Ventas
                    </div>
                  )}
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4">
                    <div className="flex items-center justify-between text-white">
                      <span className="text-sm font-semibold">
                        <i className="ri-calendar-line mr-1"></i>
                        Válido hasta: {pack.expiryDate}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="p-8">
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">
                    {pack.name}
                  </h3>
                  <p className="text-gray-600 mb-6 leading-relaxed">
                    {pack.description}
                  </p>

                  <div className="bg-orange-50 rounded-lg p-4 mb-6 border border-orange-200">
                    <h4 className="font-semibold text-gray-900 mb-3 text-sm flex items-center">
                      <i className="ri-gift-line text-orange-600 mr-2"></i>
                      Incluye:
                    </h4>
                    <ul className="space-y-2">
                      {pack.items.map((item, idx) => (
                        <li key={idx} className="flex items-center text-sm text-gray-700">
                          <i className="ri-checkbox-circle-fill text-orange-500 mr-2"></i>
                          <span><strong>{item.quantity}x</strong> {item.name}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="bg-gradient-to-br from-orange-600 to-red-600 rounded-xl p-6 mb-6 text-white">
                    <div className="flex items-end justify-between">
                      <div>
                        <p className="text-sm text-orange-100 line-through mb-1">
                          Antes: {pack.regularPrice.toFixed(2)}€
                        </p>
                        <p className="text-4xl font-bold">
                          {pack.packPrice.toFixed(2)}€
                        </p>
                        <p className="text-sm font-semibold bg-white/20 inline-block px-3 py-1 rounded-full mt-2">
                          <i className="ri-arrow-down-line mr-1"></i>
                          -{Math.round((pack.savings / pack.regularPrice) * 100)}% ({pack.savings.toFixed(2)}€)
                        </p>
                      </div>
                      <div className="text-right">
                        <div className="bg-white/20 rounded-lg px-4 py-2">
                          <p className="text-sm text-orange-100">Total</p>
                          <p className="text-2xl font-bold">
                            {pack.totalItems}
                          </p>
                          <p className="text-xs text-orange-100">unidades</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <Link to={`/paquetes/${pack.id}`}>
                    <Button fullWidth size="lg" className="bg-orange-600 hover:bg-orange-700">
                      <i className="ri-shopping-cart-line mr-2"></i>
                      Comprar Ahora
                      <i className="ri-arrow-right-line ml-2"></i>
                    </Button>
                  </Link>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-16 bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-12 text-center text-white">
            <div className="max-w-3xl mx-auto">
              <i className="ri-notification-3-line text-5xl text-orange-400 mb-4"></i>
              <h2 className="text-3xl font-bold mb-4">¿Quieres recibir las próximas ofertas?</h2>
              <p className="text-xl text-gray-300 mb-8">
                Cada día 1 del mes lanzamos nuevos packs exclusivos. Contacta con nosotros para estar al tanto de las próximas ofertas flash.
              </p>
              <Link to="/contacto">
                <Button 
                  size="lg"
                  className="bg-orange-600 hover:bg-orange-700"
                >
                  <i className="ri-mail-line mr-2"></i>
                  Contactar Ahora
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}